import { GraphChartConfigDto, ScatterChartDataDto } from 'types/CodegenReportTypes';

import { ChartProps } from 'utilities/chartIdToComponent';
import ScatterChart from 'components/ScatterChart/ScatterChart';
import { useTranslation } from 'react-i18next';
import useScatterChartData from 'hooks/useScatterChartData';

const PlayerScatterChart = ({ chartData, isLoading, extraChartData }: ChartProps<ScatterChartDataDto, GraphChartConfigDto>) => {
  const { t } = useTranslation();

  const scatterChartData = useScatterChartData(chartData?.datasets, isLoading);

  return <ScatterChart xLabel={t(extraChartData.xAxis)} yLabel={t(extraChartData.yAxis)} chartData={scatterChartData} />;
};

export default PlayerScatterChart;
